<template lang="pug">
  div
    v-btn(
      title="Задания"
      text
      :dark="unitModel === 'course_units'"
      @click.stop="openTimeOut"
    )
      v-chip(
        color="warning"
        small
      ).mr-2 {{ tasks.length }}
      span {{unitModel === 'courses' ? 'Курсовые задания' : 'Задания'}}

    v-dialog(v-model="menu" width="500px" fullscreen transition="")
      v-row.unit-task.ma-0.justify-end.relative
        v-slide-x-reverse-transition
          v-card.unit-task__card(height='100%' v-show="menuTimeout" tile).pa-5
            v-card-title Задания
            v-card-subtitle Выберите задание из списка или создайте новое

            v-list(v-if="unitModel")
              v-list-group.mb-4.mx-2.unit-task__list(
                color="primary"
              )
                template(v-slot:activator)
                  v-list-item-content.unit-task__header
                    v-list-item-title Прикрепленные задания
                v-list-item(v-for="task in tasks" :key="task.id")
                  v-list-item-title.text-truncate {{ task.title }}
                  v-list-item-action
                    v-btn(
                      :to=`{
                        name: 'TaskEdit',
                        params: { id: task.id },
                        query: { model: unitModel, id: unitId }
                      }`
                      color="warning"
                      title="Редактировать задание"
                      icon
                    )
                      v-icon mdi-pencil
                  v-list-item-action
                    v-btn(
                      @click="openDetachDialog(task.id)" icon color="error" title="Удалить задание"
                    )
                      v-icon mdi-close
                v-list-item(v-if="!tasks.length" key="no-tasks")
                  v-list-item-title Заданий пока нет
              v-list-group.mb-4.mx-2.unit-task__list(
                color="primary"
              )
                template(v-slot:activator)
                  v-list-item-content.unit-task__header
                    v-list-item-title Продолжить редактирование
                server-data(
                  ref="draftData"
                  :method="$api.tasks.getDraft"
                  :query="{ [`search[${UNITS_MODEL[unitModel].search}]`]: unitId, 'per-page': 5, }"
                  v-slot="{ serverData, loadMoreItems, loading, pagination }"
                )
                  v-skeleton-loader(
                    v-if="!serverData || loading"
                    type="list-item@3"
                  )
                  v-list-item(v-else-if="!serverData.length && !loading")
                    v-list-item-title Черновиков пока нет
                  .display-contents(v-else)
                    v-list-item(
                      width="100px"
                      link
                      v-for="draft in serverData" :key="draft.id"
                      :to=`{
                        name: 'TaskEdit',
                        query: { model: unitModel, id: unitId, type: 'draft', draftId: draft.id }
                      }`
                    )
                      v-list-item-title.text-truncate {{draft.draft_task.title}}
                      v-list-item-action
                        v-btn(
                          icon
                          color="error"
                          @click.stop.prevent="deleteDraft(draft.id, pagination.page)"
                        )
                          v-icon mdi-close
                    v-list-item(v-if="pagination.total > 1")
                      v-list-item-content
                        v-pagination(
                          v-model="pagination.page"
                          :length="pagination.total"
                          circle
                          @input="(val) => loadItems(val, 'draftData')"
                        )

              v-list-group.mb-4.mx-2.unit-task__list(
                color="primary"
              )
                template(v-slot:activator)
                  v-list-item-content.unit-task__header
                    v-list-item-title Раннее созданные задания

                server-data(
                  ref="templateData"
                  :method="$api.tasks.getTaskList"
                  :query="{ [`search[created_by]`]: $user.data.id }"
                  v-slot="{ serverData, loadMoreItems, loading, pagination }"
                )
                  v-skeleton-loader(
                    v-if="loading"
                    type="list-item@3"
                  )
                  v-list-item(
                    link
                    v-for="item in serverData"
                    :key="item.id"
                    :to=`{
                        name: 'TaskEdit',
                        params: { id: item.id },
                        query: { model: unitModel, type: 'draft', id: unitId }
                      }`
                  )
                    v-list-item-title.text-truncate {{item.title}}
                    v-list-item-icon
                      v-icon mdi-chevron-right
                  v-list-item(v-if="pagination.total > 1")
                    v-list-item-content
                      v-pagination(
                        v-model="pagination.page"
                        :length="pagination.total"
                        circle
                        @input="(val) => loadItems(val, 'templateData')"
                      )
                  //- v-btn.ma-2(
                  //-   rounded
                  //-   :to="{ name: 'TaskCreate', query: { type: 'template' } }"
                  //-   color="success"
                  //- ) Создать шаблон

            v-card-actions
              v-btn.mb-2(
                :to="{ name: 'TaskCreate', query: { model: unitModel, id: unitId } }"
                color="success"
                rounded
              )
                v-icon(left) mdi-plus
                | Добавить новое задание
        v-overlay(:value="menuTimeout" @click="openTimeOut" absolute)

    delete-dialog(
      v-model="showDetachTaskDialog"
      :request="detachRequest"
      :request-id="detachTaskId"
      success-message="Задание успешно откреплено"
      @delete="detachTask"
    )
</template>
<script>
import { UNITS_MODEL } from '@/modules/CourseManagement/constants';

export default {
  props: {
    tasks: { type: Array, default: () => ([]) },
    unitId: { type: Number, default: 0 },
    unitModel: { type: String, default: 'courses' },
  },
  data: () => ({
    UNITS_MODEL,
    menu: false,
    menuTimeout: false,
    showDetachTaskDialog: false,
    detachTaskId: null,
    drafts: [],
  }),
  methods: {
    openTimeOut() {
      this.menu = !this.menu;
      setTimeout(() => { this.menuTimeout = !this.menuTimeout; }, 100);
    },
    openDetachDialog(id) {
      this.detachTaskId = id;
      this.showDetachTaskDialog = true;
    },
    detachRequest() {
      return this.$api.tasks.detachTask(
        this.detachTaskId, {
          model: this.unitModel,
          id: this.unitId,
        },
      );
    },
    async deleteDraft(id, page) {
      await this.$rHandler(
        this.$api.tasks.deleteDraft(id),
        () => {
          this.loadItems(page, 'draftData');
        },
      );
    },
    detachTask() {
      this.$emit('task:detach', this.tasks.filter((i) => i.id !== this.detachTaskId));
      this.detachTaskId = null;
    },
    async loadItems(page, refName) {
      this.$refs[refName].loading = true;
      const resp = await this.$refs[refName].loadItems(page);
      this.$refs[refName].serverData = resp.data.data;
      this.$refs[refName].loading = false;
    },
  },
};
</script>
<style lang="scss">
.unit-task {
  height: 100%;
  pointer-events: all;

  &__card {
    z-index: 6;
    width: 50%;
  }
  &__actions {
    margin-left: 10px;
  }
  &__header {
    height: 64px;
  }
  &__list {
    background: rgba(0, 0, 0, 0.05) !important;
    border-radius: 20px;
    min-height: 64px;
    overflow: hidden;
  }
}
</style>
